import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import {logout} from '../reducers/userSlice';
export const LogoutLink = (
    props
) => {


    const navigate = useNavigate();
    const dispatch=useDispatch();
    const handleLogout =  ()=>{
        dispatch(logout());
        navigate('/login');
    }

    

    return (
        <a 
        
        href="#"
        onClick={handleLogout}
        className={props.className}>
            <span className="menu-text">Cerrar Sesión</span>
        </a>
    )
}
